import type { ErrorInfo } from 'react';

import type { TrackErrorOptions } from '../types';

const MAX_COMPONENT_STACK_CHARS = 2000;

export function buildComponentErrorReport(
  error: Error,
  info: ErrorInfo,
  { isCrash, severity, url, owner, metadata }: TrackErrorOptions,
): { error: Error; context: TrackErrorOptions } {
  const renderingError = new Error(error.message, { cause: error });
  renderingError.name = 'ReactRenderingError';
  if (error.stack) {
    renderingError.stack = error.stack;
  }

  const componentStack = info.componentStack?.trim();

  return {
    error: renderingError,
    context: {
      isCrash,
      severity,
      url,
      owner,
      metadata: {
        ...metadata,
        ...(componentStack ? { componentStack: componentStack.slice(0, MAX_COMPONENT_STACK_CHARS) } : {}),
      },
    },
  };
}
